import {computed} from "@angular/core";
import {patchState, signalStore, withComputed, withMethods, withState} from "@ngrx/signals";
import {Location} from "src/app/domain/samples/rssi/location";

interface SignalStrengthAnalysisState {
  loading: boolean,
  locations: Location[],
  visibleGateway: string | undefined
}

const initialState: SignalStrengthAnalysisState = {
  loading: true,
  locations: [],
  visibleGateway: undefined
}

export const SignalStrengthAnalysisStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods(store => ({
    reset() {
      patchState(store, initialState)
    },
    setLocations(locations: Location[]) {
      patchState(store, { locations, loading: false })
    },
    setVisibleGateway(gatewayId: string | undefined) {
      patchState(store, { visibleGateway: gatewayId })
    }
  })),
  withComputed(({locations}) => ({
    gatewayIds: computed(() => {
      return new Set(locations()
        .map(location => location.rssiPerGateway)
        .flatMap(rssisPerGateway => Object.keys(rssisPerGateway)));
    })
  }))
);
